module.exports = __webpack_public_path__ + "img/mira_440m_list.32ed7f19.jpg";